import axiosClient from '../axiosClient';

export async function getComponentEditList () {
  const response = await axiosClient.get('v2/system-metadata/edit-components');
  console.log('API-respons fra getComponentEditList:', response.data);
  return response.data;
}

export async function getBaseDataTypes () {
  const response = await axiosClient.get('v2/system-metadata/base-data-types');
  return response.data;
}

// New primary types endpoints
export interface PrimaryTypeInfoDto { key: string; label: string; allowedEditComponents: string[] }

export async function getPrimaryTypes (): Promise<PrimaryTypeInfoDto[]> {
  const response = await axiosClient.get('v2/system-metadata/primary-types');
  return response.data;
}

export interface PrimaryFieldOptionsDto {
  required?: boolean | null;
  showThousandsSeparator?: boolean | null;
  decimalPlaces?: number | null;
  numericPrecision?: number | null;
  numericScale?: number | null;
  maxLength?: number | null;
  valueList?: {
    listOfValueObjectId?: number | null;
    keyType?: 'Int' | 'BigInt' | 'Guid' | 'String' | null;
    simpleList?: Array<{ label: string; value: string }> | null;
    simpleListSeparator?: string | null;
  } | null;
}

export interface FieldParameterDto {
  type: 'maxLength' | 'precision' | 'scale';
  isRequired: boolean;
  defaultValue?: number | null;
  minValue?: number | null;
  maxValue?: number | null;
  allowedValues?: string[] | null;
}

export interface FieldDesignDto {
  fieldType: string;
  storage: {
    baseDataType: string;
    maxLength?: number | null;
    precision?: number | null;
    scale?: number | null;
    textWithMaxLength?: boolean;
    parameters?: FieldParameterDto[] | null;
  };
  edit: {
    componentEdit: string;
    numberFormatShowThousandsSeparator?: boolean | null;
    numberFormatDecimalPrecision?: number | null;
    isMultiSelect?: boolean | null;
    simpleList?: Array<{ label: string; value: string }> | null;
  };
  defaults: {
    allowLiteral: boolean;
    allowedFunctions: string[];
  };
  allowedEditComponents: string[];
}

export async function resolvePrimaryType (primaryType: string, options: PrimaryFieldOptionsDto): Promise<FieldDesignDto> {
  const response = await axiosClient.post('v2/system-metadata/primary-types/resolve', options, {
    params: { type: primaryType }
  });
  return response.data;
}

// ComponentEdit to PrimaryType mapping
export interface ComponentEditPrimaryTypeMapping {
  componentEdit: string;
  primaryFieldType: string;
}

export async function getComponentEditMapping (): Promise<ComponentEditPrimaryTypeMapping[]> {
  const response = await axiosClient.get('v2/system-metadata/component-edit-mapping');
  return response.data;
}
